export default __webpack_public_path__ + "static/media/tete33.89f022a4.png";